import {
  Component,
  OnInit,
  Input,
  ViewContainerRef,
  ViewEncapsulation
} from '@angular/core';

@Component({
  selector: 'app-create-special-disclosure',
  templateUrl: './create-special-disclosure.component.html',
  providers: [  ],
  encapsulation: ViewEncapsulation.None
})

export class CreateSpecialDisclosureComponent implements OnInit {

  constructor(){}

  public ngOnInit():void {}

}
